interface PersonProfileProps {
  photoUrl: string;
  name: string;
  description: React.ReactNode;
}

const PersonProfile = ({ photoUrl, name, description }: PersonProfileProps) => {
  const textVerdeOliva = "text-[#d2de00]";

  return (
    <div className="group bg-gradient-to-br from-[#292929] to-[#1a1a1a] p-6 md:p-8 rounded-2xl max-w-[300px] md:max-w-[320px] mx-auto relative shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-700/30 hover:border-[#d2de00]/30">
      {/* Photo container that extends outside the card */}
      <div className="absolute -top-20 md:-top-28 left-1/2 transform -translate-x-1/2">
        <div className="w-36 h-44 md:w-48 md:h-56 rounded-2xl overflow-hidden border-4 border-[#d2de00] shadow-xl group-hover:scale-105 transition-transform duration-300">
          <img 
            src={photoUrl} 
            alt={name}
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      
      {/* Content with top margin to account for protruding photo */}
      <div className="mt-28 md:mt-32 text-center text-white">
        <h3 className={`font-bold text-lg mb-4 ${textVerdeOliva} uppercase tracking-wide`}>
          {name}
        </h3>
        <div className="text-gray-300 text-sm leading-relaxed">
          {description}
        </div>
      </div>
      
      {/* Decorative element */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-gradient-to-r from-[#d2de00] to-[#a8b600] rounded-full opacity-50 group-hover:opacity-100 transition-opacity duration-300"></div>
    </div>
  );
};

export default PersonProfile;